import React, { useEffect, useRef, useState } from 'react'
import styles from './DisplayBoard/DisplayBoard.module.css';
import stylesPrototype from './Prototype/Prototype.module.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
// import Froala from 'components/Project/froala';
import { RichBox } from 'components/RichBoxComponent';
import { slotShouldForwardProp } from '@mui/material/styles/styled';


const Prototype = (props) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    // -------------------------------------------------------------------------------
    const [materialsList, setMaterialsList] = useState([]);
    const [materialsBar, setMaterialsBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [buildingPrototype, setBuildingPrototype] = useState("")
    const [buildingPrototypeBar, setBuildingPrototypeBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [testingPrototype, setTestingPrototype] = useState("")
    const [testingPrototypeBar, setTestingPrototypeBar] = useState(0);
    // -------------------------------------------------------------------------------
    const [itterationText, setItterationText] = useState("")
    const [itterationTextBar, setItterationTextBar] = useState(0);

    useEffect(() => {
        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/prototype/getprototype.php`)
            .then(res => {
                let hasFailedFlag = true
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                    // // console.log("res_data_data")
                    // // console.log(res_data_data)
                    if (res_data_data.hasOwnProperty("prototype")) {
                        hasFailedFlag = false
                        const tmp_prototype = res_data_data?.prototype;
                        // -------------------------------------------------------------------------------
                        if (tmp_prototype?.hasOwnProperty("building_prototype")) {
                            setBuildingPrototype(tmp_prototype["building_prototype"])
                        }
                        if (tmp_prototype?.hasOwnProperty("building_prototype_bar")) {
                            setBuildingPrototypeBar(tmp_prototype["building_prototype_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_prototype?.hasOwnProperty("testing_prototype")) {
                            setTestingPrototype(tmp_prototype["testing_prototype"])
                        }
                        if (tmp_prototype?.hasOwnProperty("testing_prototype_bar")) {
                            setTestingPrototypeBar(tmp_prototype["testing_prototype_bar"] ?? 0)
                        }
                        // -------------------------------------------------------------------------------
                        if (tmp_prototype?.hasOwnProperty("itteration")) {
                            setItterationText(tmp_prototype["itteration"])
                        }
                        if (tmp_prototype?.hasOwnProperty("itteration_bar")) {
                            setItterationTextBar(tmp_prototype["itteration_bar"] ?? 0)
                        }

                        if (tmp_prototype?.hasOwnProperty("matlistitems")) {
                            setMaterialsList(tmp_prototype["matlistitems"])
                        }
                    }
                }
                if (hasFailedFlag) {
                    Swal.fire("Sorry, try again later", "", "error")
                } else {
                    Swal.close();
                    setDataLoaded(true)
                }
            }).catch(err => {
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })
    }, [])


    const handleSend = (field, text, bar) => {
        if ((text??"").trim() === "") {
            Swal.fire("Sorry, But you have to write in the text input field", "", "error")
        } else {
            // // // console.log("globalState?.permissions?.fullname")
            // // // console.log(props.globalState?.permissions?.id)
            // globalState?.permissions?.fullname

            // // console.log("handleSend 1 ")
            Swal.showLoading();
            axios.post(`${BASE_URL}/capstone/prototype/setprototype.php`, {
                field: field,
                content: text,
                bar
            })
                .then(res => {
                    // // console.log("handleSend res ")
                    let hasFailedFlag = true
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                        // // // console.log("res_data_data")
                        // // // console.log(res_data_data)
                        if (res_data_data.hasOwnProperty("ok")) {
                            hasFailedFlag = false
                            Swal.fire("Saved", "", "success")
                        }
                    }
                    if (hasFailedFlag) {
                        Swal.fire("Sorry, try again later", "", "error")
                    }
                }).catch(err => {
                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                })


        }
    };

    useEffect(() => {
        if (materialsList.length) {
            let complete = 0;
            materialsList.forEach(y => {
                if (y.check - 0) complete++;
            })
            setMaterialsBar((complete / materialsList.length) * 100)
        }
        else {
            setMaterialsBar(0)
        }
    }, [materialsList])

    const handleAddMaterialsList = () => {

        Swal.fire({
            title: 'Enter a name',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Save',
            confirmButtonColor: 'green',
            cancelButtonText: 'Cancel',
            cancelButtonColor: "red",
            input: "text",
            // inputLabel: "Your IP address",
            // inputValue: x.name,
            inputValidator: (value) => {
                if (!value) {
                    return "You need to give it a name!";
                }
            }
        }).then((result) => {
            if (result.value) {
                const x = {
                    name: result.value,
                    check: false
                }

                Swal.showLoading();
                axios.post(`${BASE_URL}/capstone/prototype/saveprototypematlist.php`, x)
                    .then(res => {
                        // // console.log("handleSend res ")
                        let hasFailedFlag = true
                        if (res?.data?.data) {
                            const res_data_data = res?.data?.data;
                            // // // console.log("res_data_data")
                            // // // console.log(res_data_data)
                            if (res_data_data.hasOwnProperty("ok")) {
                                hasFailedFlag = false
                                x.id = res_data_data["id"]
                                setMaterialsList(y => [...y, x])
                                Swal.fire("Saved", "", "success")
                            }
                        }
                        if (hasFailedFlag) {
                            Swal.fire("Sorry, try again later", "", "error")
                        }
                    }).catch(err => {
                        Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                    })


            }
        })
    }
    if (!dataLoaded) {
        return <h2>Loading...</h2>
    } else {
        return (
            <div>
                {/* ======================================================================================== */}

                <div className={`${styles.section} mt-5`} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Materials and tools are ready</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Materials and tools are ready</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={materialsBar}
                                disabled
                                onChange={e => {
                                    Swal.fire("Sorry, this bar updates automatically", "", "error")
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{Number(materialsBar).toFixed(0)}%</span>
                            </span>
                        </div>
                    </div>

                    <p className=' mt-1  ' style={{ color: "red" }} >*Note that this section saves each update automatically , that's not the case with other sections.</p>
                    <p className=' mt-1  ' style={{ color: "red" }} >*Note that this bar updates automatically.</p>
                    <p className=' mt-1  ' style={{ color: "red" }} >*Checking the box means that you have the material.</p>

                    {/* ----------------------------------------------------------------------------- */}
                    <div>
                        {
                            materialsList.length ?
                                materialsList.map((x, i) => (
                                    <div className={stylesPrototype.materials_list_item} key={x.hasOwnProperty("id") ? x.id : ((x.name != "") ? x.name : i)} >
                                        <div>{x.name}</div>
                                        <div className={stylesPrototype.materials_list_item_btns} >
                                            <input type="checkbox"
                                                checked={x.check - 0}
                                                onChange={e => {
                                                    // // console.log(e)
                                                    // // console.log(e?.target)
                                                    // // console.log(e?.target?.checked)


                                                    const new_check = e?.target?.checked
                                                    Swal.showLoading();
                                                    axios.post(`${BASE_URL}/capstone/prototype/saveprototypematlist.php`, {
                                                        ...x,
                                                        check: new_check
                                                    })
                                                        .then(res => {
                                                            // // console.log("handleSend res ")
                                                            let hasFailedFlag = true
                                                            if (res?.data?.data) {
                                                                const res_data_data = res?.data?.data;
                                                                // // // console.log("res_data_data")
                                                                // // // console.log(res_data_data)
                                                                if (res_data_data.hasOwnProperty("ok")) {
                                                                    hasFailedFlag = false
                                                                    x.check = new_check
                                                                    setMaterialsList(y => [...y])
                                                                    Swal.fire("Saved", "", "success")
                                                                }
                                                            }
                                                            if (hasFailedFlag) {
                                                                Swal.fire("Sorry, try again later", "", "error")
                                                            }
                                                        }).catch(err => {
                                                            Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                                                        })


                                                }}
                                            />

                                            <button className='btn btn-secondery'
                                                onClick={e => {

                                                    Swal.fire({
                                                        title: 'Enter a name',
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Save',
                                                        confirmButtonColor: 'green',
                                                        cancelButtonText: 'Cancel',
                                                        cancelButtonColor: "red",
                                                        input: "text",
                                                        // inputLabel: "Your IP address",
                                                        inputValue: x.name,
                                                        inputValidator: (value) => {
                                                            if (!value) {
                                                                return "You need to give it a name!";
                                                            }
                                                        }
                                                    }).then((result) => {

                                                        if (result.value) {
                                                            // x.name = result.value

                                                            const new_name = result.value
                                                            Swal.showLoading();
                                                            axios.post(`${BASE_URL}/capstone/prototype/saveprototypematlist.php`, {
                                                                ...x,
                                                                name: new_name
                                                            })
                                                                .then(res => {
                                                                    // // console.log("handleSend res ")
                                                                    let hasFailedFlag = true
                                                                    if (res?.data?.data) {
                                                                        const res_data_data = res?.data?.data;
                                                                        // // // console.log("res_data_data")
                                                                        // // // console.log(res_data_data)
                                                                        if (res_data_data.hasOwnProperty("ok")) {
                                                                            hasFailedFlag = false
                                                                            x.name = new_name
                                                                            setMaterialsList(y => [...y])
                                                                            Swal.fire("Saved", "", "success")
                                                                        }
                                                                    }
                                                                    if (hasFailedFlag) {
                                                                        Swal.fire("Sorry, try again later", "", "error")
                                                                    }
                                                                }).catch(err => {
                                                                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                                                                })



                                                        }
                                                    })
                                                }}
                                            ><i class="fas fa-edit"></i></button>

                                            <button className='btn btn-danger'
                                                onClick={e => {
                                                    // // console.log(e)
                                                    // // console.log(e?.target)
                                                    // // console.log(e?.target?.checked)

                                                    Swal.showLoading();
                                                    axios.post(`${BASE_URL}/capstone/prototype/deleteprototypematlist.php`, { id: x.id })
                                                        .then(res => {
                                                            // // console.log("handleSend res ")
                                                            let hasFailedFlag = true
                                                            if (res?.data?.data) {
                                                                const res_data_data = res?.data?.data;
                                                                // // // console.log("res_data_data")
                                                                // // // console.log(res_data_data)
                                                                if (res_data_data.hasOwnProperty("ok")) {
                                                                    hasFailedFlag = false
                                                                    setMaterialsList(y => y.filter((z, k) => i != k))
                                                                    Swal.fire("Deleted", "", "success")
                                                                }
                                                            }
                                                            if (hasFailedFlag) {
                                                                Swal.fire("Sorry, try again later", "", "error")
                                                            }
                                                        }).catch(err => {
                                                            Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                                                        })


                                                }}
                                            ><i class="fas fa-trash"></i></button>

                                        </div>
                                    </div>
                                )) : <h5 style={{
                                    textAlign: "center",
                                }} className="m-5">Please add the materials you need</h5>
                        }
                    </div>
                    {/* ----------------------------------------------------------------------------- */}
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={handleAddMaterialsList}
                        ><i class="fas fa-plus-circle"></i></button>
                    </div>
                </div>

                {/* ======================================================================================== */}

                <p className=' mt-4  ' style={{ color: "red" }} >*Note that the "Save" button is for the whole section , so if you modify either of the slider or the text you need to push it.</p>

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Building prototype</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={buildingPrototypeBar}
                                onChange={e => {
                                    setBuildingPrototypeBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{buildingPrototypeBar}%</span>
                            </span>
                        </div>
                    </div>
                    <RichBox
                        defaultValue={buildingPrototype}
                        onChange={setBuildingPrototype}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "building_prototype"
                                const text = buildingPrototype
                                const bar = buildingPrototypeBar
                                handleSend(field, text, bar)
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Testing prototype</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={testingPrototypeBar}
                                onChange={e => {
                                    setTestingPrototypeBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{testingPrototypeBar}%</span>
                            </span>
                        </div>
                    </div>
                    <RichBox
                        defaultValue={testingPrototype}
                        onChange={setTestingPrototype}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='prototypeSectionInput'
                            value={testingPrototypeBar}
                            onChange={e => {
                                setTestingPrototypeBar(e.target.value)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "testing_prototype"
                                const text = testingPrototype
                                const bar = testingPrototypeBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Itteration</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Itteration</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                // className='PortfolioSectionInput'
                                value={itterationTextBar}
                                onChange={e => {
                                    setItterationTextBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{itterationTextBar}%</span>
                            </span>
                        </div>
                    </div>

                    <RichBox
                        defaultValue={itterationText}
                        onChange={setItterationText}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        {/* <input type="range" min="0" max="100"
                            // className='prototypeSectionInput'
                            value={itterationTextBar}
                            onChange={e => {
                                setItterationTextBar(e.target.value)
                                // // console.log("itterationText input")
                                // // console.log(itterationText)
                            }}
                        /> */}

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "itteration"
                                const text = itterationText
                                const bar = itterationTextBar
                                // // console.log("itterationText")
                                // // console.log(text)
                                if (text) {
                                    // // console.log("itterationText text")
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>

            </div >
        )
    }
}

export default Prototype